import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./app.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import { PostRequest } from "../../utils/ApiServices";
import { Spinner } from "react-bootstrap";

export function ForgotPassword() {
  const navigate = useNavigate();
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const { value } = useParams();
  const parts = value.split("=");
  const encodedToken = parts[1];
  const [id, setID] = useState(null);

  const fetchdata = async () => {
    const res = await PostRequest("check-password-email", {
      token: encodedToken,
    });
    if (res) {
      setID(res?.id);
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    if (value) {
      fetchdata();
    }
  }, [value]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (newPwd !== confirmPwd) {
      toast.error("Password Do not Match", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    } else {
      const res = await PostRequest("change-password", {
        id: id,
        password: newPwd,
      });
      if (res) {
        toast.success("Password Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        navigate("/");
      }
    }
    setLoading(false);
  };

  return (
    <div className="main-container">
      <Helmet>
        <title>Reset Password</title>
      </Helmet>
      <div className="forget-section">
        <form className="form" onSubmit={handleSubmit}>
          <h2>Enter Password</h2>
          <div className="single-form col-xs-12 col-sm-12 col-md-12">
            <input
              type="password"
              name="password"
              placeholder="New password"
              onChange={(e) => setNewPwd(e.target.value)}
            />
          </div>

          <div className="single-form col-xs-12 col-sm-12 col-md-12">
            <input
              type="password"
              name="confirmpassword"
              placeholder="Confirm password"
              onChange={(e) => setConfirmPwd(e.target.value)}
            />
          </div>

          <div className="single-form col-xs-12 col-sm-12 col-md-12">
            <button
              className="btn btn-primary btn-hover-dark "
              disabled={loading}
            >
              {!loading ? (
                <>
                  Confirm{" "}
                  <i className="flaticon-right" onChange={setConfirmPwd} />
                </>
              ) : (
                <div className="">
                  <Spinner size="sm" />
                </div>
              )}
            </button>
          </div>

          {/* <div
            className="single-form col-xs-12 col-sm-12 col-md-12 "
            id="login-link"
          >
            or{" "}
            <Link to="/login">
              <span>Login</span>
            </Link>
          </div> */}
        </form>
      </div>
    </div>
  );
}
